import getReduxSelector from 'modules/redux/selectors/get'
import {
  TEMPORARY_UNLOCKED_SAMPLES_KEY,
  TEMPORARY_UNLOCKED_SAMPLES_PATH
} from 'modules/temporary-unlocked-samples/redux/state'

const getTimeRemainingTemporaryUnlockedSamplesBannerSelect = state => {
  const path = TEMPORARY_UNLOCKED_SAMPLES_PATH[TEMPORARY_UNLOCKED_SAMPLES_KEY.TIME_REMAINING]
  return getReduxSelector(path)(state)
}

export default getTimeRemainingTemporaryUnlockedSamplesBannerSelect
